const benchmarks = [
  {
    name: "CORGI",
    vertical: "Insurance",
    stats: "$108M raised · $630M valuation",
    detail: "Seed + Series A, Jan 2026",
    description: "AI-native carrier. Owns the entity.",
    quote: "\"Why sell software to insurers when you can be the insurer?\"",
    color: "var(--color-accent)",
    logo: "/bench-corgi.svg",
  },
  {
    name: "CRETE",
    vertical: "Accounting",
    stats: "$300M+ revenue · 20+ firms",
    detail: "Backed by Thrive Capital + Bessemer Venture Partners",
    description: "Thrive Capital backed. AI-enabled roll-up.",
    quote: "Accounting Today's fastest-growing firm 2025.",
    color: "#818cf8",
    logo: "/bench-crete.webp",
  },
  {
    name: "HARVEY",
    vertical: "Legal AI",
    stats: "$1.2B raised · $11B valuation",
    detail: "Series G, Mar 2026 · $190M ARR",
    description: "SaaS for law firms. Sells software, doesn't own firms.",
    quote: "Validates the market COSX operates in.",
    color: "#a5b4fc",
    logo: "/bench-harvey.png",
  },
];

export function V2ValuationBenchmarksSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <h2 className="text-[32px] font-light tracking-tight mb-1 font-[family-name:var(--font-heading)]">
        AI + regulated industries = premium valuations.
      </h2>
      <p className="text-[13px] text-[var(--color-fg-secondary)] font-light mb-5">
        Companies combining AI with regulated industry ownership are attracting outsized capital and valuations.
      </p>

      <div className="grid grid-cols-3 gap-4">
        {benchmarks.map((b) => (
          <div key={b.name} className="border border-[var(--color-border)] rounded-sm p-5 flex flex-col relative overflow-hidden">
            <img src={b.logo} alt="" className="absolute top-3 right-3 h-[40px] w-auto opacity-[0.07]" />
            <div className="flex items-center gap-2 mb-3 relative">
              <div className="w-2 h-2 rounded-full shrink-0" style={{ background: b.color }} />
              <div className="text-[12px] font-[family-name:var(--font-mono)] font-bold uppercase tracking-[0.1em]">
                {b.name} <span className="font-normal text-[var(--color-fg-tertiary)]">— {b.vertical}</span>
              </div>
            </div>
            <div className="text-[18px] font-light tracking-tight font-[family-name:var(--font-heading)] mb-0.5">
              {b.stats}
            </div>
            <div className="text-[9px] font-[family-name:var(--font-mono)] text-[var(--color-fg-tertiary)] mb-3">
              {b.detail}
            </div>
            <p className="text-[12px] text-[var(--color-fg-secondary)] leading-relaxed mb-2">
              {b.description}
            </p>
            <p className="text-[11px] text-[var(--color-fg-tertiary)] italic mt-auto">
              {b.quote}
            </p>
          </div>
        ))}
      </div>

      <p className="text-[10px] text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)] mt-4 leading-relaxed">
        General Catalyst allocated $1.5B to AI-enabled roll-ups. Thrive Capital launched $1B+ for the same strategy. Y Combinator&apos;s 2025 RFS: &quot;Start your own law firm, staff it with AI agents.&quot;
      </p>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          Corgi proved the model in insurance. Crete proved it in accounting. Harvey proved the market for legal AI.
        </p>
        <p className="text-[12px] font-medium text-[var(--color-fg)] mt-0.5">
          COSX combines all three: own the firm, build the AI, compound across regulated industries and jurisdictions.
        </p>
      </div>
    </div>
  );
}
